import { Response } from "models";
import { mapServerErrors } from "helpers/api";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { getTokens, removeTokens, saveTokens } from "store/auth";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {toast} from "react-toastify";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_BASE_URL + "/api";

const clientInstant = axios.create({baseURL});

clientInstant.interceptors.request.use((config) => {
  const { token } = getTokens();
  const currentLanguageCode = Cookies.get("i18next") || "en";

  if (token) {
    config.headers!.authorization = `Bearer ${token}`;
  }
  config.headers!["Accept-Language"] = currentLanguageCode
  return config;
});

export async function handleRefreshToken(call?: any) {
  const { token, refreshToken, expirationDate } = getTokens();

  try {
    const { data: response } = await axios.post( baseURL + "/auth/refreshToken",{ token, refreshToken });

    if (response.isSuccess) {
      saveTokens( response.data.token, response.data.refreshToken, expirationDate ? new Date(expirationDate) : undefined);
      call && (call.response.config.headers["authorization"] = "Bearer " + response.data.token);
      return Promise.resolve();
    } else {
      removeTokens();
      window.location.reload();
      return Promise.reject();
    }
  } catch (e) {
    removeTokens();
    window.location.reload();
    return Promise.reject();
  }
}

createAuthRefreshInterceptor(clientInstant, handleRefreshToken);

export function client<T>(endpoint: string, { data, ...configs }: AxiosRequestConfig = {}) {
  return clientInstant({
    data,
    url: endpoint,
    method: data ? "POST" : "GET",
    ...configs
  })
    .then((axiosResponse: AxiosResponse<Response<T>>) => {
      if (axiosResponse.status === 204) {
        toast.error("server error please try again");
        throw new Error("server error");
      }
      return axiosResponse.data;
    })
    .then((response) => {
      if (response.isSuccess) {
        return { response: response.data, error: null };
      } else {
        const errors = mapServerErrors(response);
        return { response: null, error: errors };
      }
    })
    .catch((err) => {
      return { response: null, error: err };
    });
}
